module.exports = __webpack_public_path__ + "img/D201810_1.5d37944a.jpg";